import { Typography } from 'fitify-ui-onboarding/src/components/Typography'
import { BREAKPOINTS } from 'fitify-ui-onboarding/src/utils/styled'
import { styled } from 'styled-components'

import type {
  ChoiceCardHorizontalHookPageConfig,
  ChoiceCardHorizontalPageConfig,
} from 'components/GenderFunnel/ChoiceCardPage/ChoiceCardPage.Types'
import type { BackgroundImageAlign } from 'components/GenderFunnel/Layout/BackgroundImage/BackgroundImage.Styled'

export const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
`

export const StyledOneColumnGrid = styled.div<{
  $imageAlign?: ChoiceCardHorizontalPageConfig['align']
  $widthVariant?: ChoiceCardHorizontalPageConfig['choicesWidthVariant']
}>`
  display: flex;
  width: ${({ $widthVariant }) => ($widthVariant === '60-mobile' ? 60 : 100)}%;
  flex-direction: column;
  align-self: ${({ $imageAlign }) =>
    $imageAlign === 'left' ? 'flex-end' : 'flex-start'};
  gap: 0.5rem;

  @media ${BREAKPOINTS.MD} {
    width: 100%;
  }
`

export const StyledHookContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const StyledHookOneColumnGrid = styled.div<{
  $imageAlign?: BackgroundImageAlign
  $pageVariant?: ChoiceCardHorizontalHookPageConfig['variant']
}>`
  display: flex;
  width: 50%;
  flex-direction: column;
  align-self: ${({ $imageAlign }) =>
    $imageAlign === 'left' ? 'flex-end' : 'flex-start'};
  padding-top: ${({ $pageVariant }) =>
    $pageVariant === 'compact' ? 0.75 : 3}rem;
  gap: 0.5rem;
`

export const StyledTwoColumnGrid = styled.div`
  display: grid;
  width: 100%;
  gap: 0.5rem;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-rows: repeat(auto-fill, 1fr);
`

export const StyledChooseTypography = styled(Typography)`
  width: 100%;
  padding: 0.25rem 0;
  color: ${({ theme }) => theme.colors['N Content/Secondary']};
`

export const StyledBottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: auto;
  gap: 0.25rem;
`
